var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-8 py-2 px-6",staticStyle:{"background-color":"#716263"}},[_c('div',{staticClass:"text-h5 my-4 text-center font-weight-bold"},[_vm._v("¿A qué esperas para activar la versión completa?")]),_vm._v(" "),_c('h-purchase-btn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }